import React from "react";
import { useFormContext } from "react-hook-form";
import { Text } from "$components";
import CField from "$forms/CField";
import FileUploader from "$components/FileUploader/FileUploader";
import { useProjectForm } from "../context/ProjectFormContext";
import useAuth from "$hooks/useAuth";

export const ProjectFormAttachments: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { isAdmin } = useAuth();
  const { currentCompany, project } = useProjectForm();

  return (
    <>
      <div className="bordered">
        <Text type="h3">Pièces jointes</Text>
      </div>
      <CField control={control} name="medias" error={errors.medias}>
        {(props) => (
          <FileUploader
            company={currentCompany}
            type="project"
            id={project?._id}
            isEdit={false}
            isLargeVersion
            {...props}
            isAdmin={isAdmin}
          />
        )}
      </CField>
    </>
  );
};
